'use client';

export { default } from './Divider';
export { default as dividerClasses } from './dividerClasses';
export * from './dividerClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Divider/index.js
// module id = 516
// module chunks = 25